import classNames from 'classnames'
import { divider } from './Divider.css'
import { sprinkles, Sprinkles } from '../../theme/sprinkles.css'

interface Props {
	space?: Sprinkles['paddingY']
	borderColor?: Sprinkles['borderColor']
	size?: keyof typeof divider
}

export const Divider = ({ space = 'md', borderColor = 'neutral.dark', size = 'sm' }: Props) => {
	const className: Sprinkles = {
		marginY: space,
		width: 'fullWidth',
		borderColor
	}

	return <hr className={classNames(divider[size], sprinkles(className))} />
}
